import AppState from "store/AppState";

export const selectRunningSearchReindex = (state: AppState) =>
  state.searchReindex.running;

export const selectLastSearchReindexResult = (state: AppState) =>
  state.searchReindex.lastResult;

export const selectIsSubmittingSearchReindex = (state: AppState) =>
  state.searchReindex.submitting;
